import React from 'react';
import { ScorecardLayout } from '../types';
import { ScorecardLayoutProps } from './types';
import ScorecardCarouselLayout from './ScorecardCarouselLayout';
import ScorecardSegmentedLayout from './ScorecardSegmentedLayout';

export type { ScorecardLayoutProps } from './types';

/**
 * Registry of layout variants for the scorecard widget. To add a new
 * variant: drop a new file under this folder, then map it here.
 */
export const SCORECARD_LAYOUT_COMPONENTS: Record<
  ScorecardLayout,
  React.ComponentType<ScorecardLayoutProps>
> = {
  carousel: ScorecardCarouselLayout,
  segmented: ScorecardSegmentedLayout,
};
